export default __webpack_public_path__ + "static/media/logo_vinpearl.712470d9.png";